import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
 import './classes/ManageBlogPost.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Helmet } from 'react-helmet';
import { useLocation,useNavigate,useSearchParams } from 'react-router-dom';
import Loading from './Loading';

const columns = [
  {
    field: 'title',
    headerName: 'Title',
    cellClassName:'title_column',headerClassName:'title_header',
    minWidth: 150, 
    flex:1,  
    sortable: false,
    filterable: false,
    renderCell: (params) => (
        <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.title}
        </Link>
    ),
    
  },
  {
    field: 'edit_link',
    headerName: 'Edit Link',
    cellClassName:'edit_link_column',headerClassName:'edit_link_header',
    minWidth: 130, 
    flex:1,  
    sortable: false,
    filterable: false, // not filterable
    renderCell: (params) => (
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'edit'}
      </Link>
    ),
  },
];

const ManageBlogPost =() =>{
  /* Pagination, filter config starts here */
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [isLoading, setIsLoading] = useState(true);
    const app_url = configData.APP_URL;
    const location  = useLocation();
    const successDeleteMessage = location.state?.message; // Access the message
    // window.history.replaceState({}, '');

    const initialBlogFilter = {
        status:'1',
        title:'',
    };

    const [formData, setFormData] = useState(initialBlogFilter);
    const[successMessage,setSuccessMessage] = useState('');
    useEffect(() => {
          if (successDeleteMessage) {
            setSuccessMessage(successDeleteMessage);
            window.history.replaceState({}, '');
          }
        }, [successDeleteMessage, location.state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    React.useEffect(() => {
        const fetchData = async () => {
        try {
        const response = await fetch(app_url+'smwwblog/manageblogpost', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
            formData:formData
            }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
        }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
    

        };

        fetchData();
    }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

    const handleSubmit = async (e) => {
        e.preventDefault(); // stop page reload
        console.log(formData);
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'smwwblog/manageblogpost', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                formData:formData
                }),
            });
            const data = await response.json();
            
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        } 
    };
 
    return(
      <>
        {isLoading ? (
            <Loading />
        ) : (
        <div id="main">
            <div className="left"></div>
            <>
                <div className="center left-center">
                    <div className="manage-blog-container">
                      <Helmet><title>Manage Blog</title></Helmet>
                        {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        <div>
                            <p><a href="/node/add/blog">Create Blog</a></p>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div>
                                        <label htmlFor="edit-status">Published</label>
                                        <div>
                                            <select 
                                                id="edit-status"
                                                name="status"
                                                onChange={handleChange}
                                                value={formData.status}
                                            >
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="edit-body-value">Title</label>
                                        <div>
                                            <input 
                                                type="text" 
                                                id="edit-title"
                                                name="title" 
                                                onChange={handleChange}
                                                value={formData.title}
                                                size={30} 
                                                maxlength={128}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <input type="submit" value="Apply" className="form-submit" />    
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="manage-blog-view-content">
                            <table className="manage-blog-view-table">
                                <div style={{ width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        rowCount={rowCount}
                                        paginationMode="server"
                                        sortingMode="server"
                                        filterMode="server"
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={setPaginationModel}
                                        sortModel={sortModel}
                                        onSortModelChange={setSortModel}
                                        filterModel={filterModel}
                                        onFilterModelChange={setFilterModel}
                                        pageSizeOptions={[5, 10, 25,50]}
                                        getRowId={() => crypto.randomUUID()}
                                        getRowHeight={() => 'auto'}
                                        disableColumnFilter 
                                        disableColumnResize={true}
                                    />
                                </div>
                            </table>
                        </div>
                    </div>
                </div>
            </>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        </div>
       )}
    </>  
    );
};

export default ManageBlogPost;